import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetDepartments = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/departments/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load departments.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const GetActiveDepartments = GetDepartments;


export const CreateDepartment = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/departments`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create department.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateDepartment = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/departments/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update department.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteDepartment = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/departments/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete department.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
